import Icon from '@components/dataDisplay/Icons/Icon';
import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import { ACCESS_TYPE, ACCESS_TYPE_VALUE } from '@typings/common/accessType';
import { NumberSec } from '@styles/common/NumberSec';

const ItemContainer = styled.div`
  border-radius: var(--cardBorderRadius);
  background-color: var(--cardBackgroundColor);
  padding: 20px;
  display: flex;
  align-items: center;
  backdrop-filter: blur(6px);
`;

const SecretBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--subTextColor);
  font-size: 13px;
`;

type Props = {
  children?: any;
  accessType: ACCESS_TYPE_VALUE;
  numberId?: number;
  style?: CSSProperties;
};
function SecretItem({ children, accessType, numberId, style }: Props) {
  const AccessMap = {
    [ACCESS_TYPE.MEMBER]: (
      <>
        {numberId && <NumberSec>No.{numberId}</NumberSec>}
        <span>멤버 공개 게시글</span>
      </>
    ),
    [ACCESS_TYPE.SECRET]: (
      <>
        {numberId && <NumberSec>No.{numberId}</NumberSec>}
        <span>비공개 게시글</span>
      </>
    ),
    [ACCESS_TYPE.PASSWORD]: (
      <>
        {numberId && <NumberSec>No.{numberId}</NumberSec>}
        <span>비공개(비밀번호) 게시글</span>
      </>
    ),
  };
  return (
    <ItemContainer style={style}>
      <SecretBox>
        <Icon name="Lock14" color="var(--subTextColor)" />
        {AccessMap[accessType]}
      </SecretBox>
    </ItemContainer>
  );
}

export default SecretItem;
